"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVolumeFromGroupId = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/**
 * Get the volume from a group id
 * @param groupId
 * @param callback
 * @param audioContext
 * @returns {Promise<number>}
 */
var getVolumeFromGroupId = exports.getVolumeFromGroupId = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(groupId, callback, audioContext) {
    var constraints, stream, volume, analyser, microphone, scriptProcessor, _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          constraints = {
            audio: {
              groupId: groupId
            }
          };
          stream = null;
          volume = 0;
          _context.prev = 1;
          _context.next = 2;
          return navigator.mediaDevices.getUserMedia(constraints);
        case 2:
          stream = _context.sent;
          analyser = audioContext.createAnalyser();
          microphone = audioContext.createMediaStreamSource(stream);
          scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);
          analyser.smoothingTimeConstant = 0.8;
          analyser.fftSize = 512;
          microphone.connect(analyser);
          analyser.connect(scriptProcessor);
          scriptProcessor.connect(audioContext.destination);
          scriptProcessor.onaudioprocess = function () {
            var array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            var arraySum = array.reduce(function (a, value) {
              return a + value;
            }, 0);
            // round the volume to the 10s as it is so precise it causes the control to rerender a lot
            volume = Math.round(arraySum / array.length / 10) * 10;
            callback(volume);
          };
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          console.error('Unable to get volume from device: ', _t);
          callback(0);
        case 4:
          return _context.abrupt("return", volume);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function getVolumeFromGroupId(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();